<app-quarantine-placement-form [config]="config" />


